module.exports = __webpack_public_path__ + "media/wordsadd.b82a9aa9.mp4";